import {useBreadcrumbStore} from '@/store/breadcrumb'
import {BreadCrumbEntry} from 'types'

export default function useBreadcrumb(breadcrumbs: BreadCrumbEntry[]) {
  const breadcrumbStore = useBreadcrumbStore()
  breadcrumbStore.setPaths(breadcrumbs)
}
